import { flow, getEnv, Instance } from "mobx-state-tree";
import { reaction } from "mobx";

import { appSessionStorage } from "../storage/SessionStorageService";
import { globalModule } from "../service-provider/GlobalModule";
import { api } from "../api/ApiService";
import { StorageModel } from "../storage/StorageModel";
import { organizationSubscriptionService } from "../organization/OrganizationSubscription";
import { endpoints } from "../api/ApiEndpoints";

const PermissionsStorageKey = "permissions";

export const PermissionsServiceModel = StorageModel.named("PermissionsServiceModel")
  .actions((self) => ({
    reloadPermissions: flow(function* reloadPermissions() {
      getEnv(self).appSessionStorage.removeStorageItem(PermissionsStorageKey);
      yield self.load();
    }),
    mapResponse(response: any) {
      if (typeof response === "string") {
        self.data = JSON.parse(response);
      } else {
        self.data = response;
      }
    },
  }))
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("permissions");
      return endpoint;
    },
    get canLoadItems() {
      return getEnv(self).organizationSubscriptionService.data;
    },
    get permissions() {
      return self.data;
    },
  }))
  .views((self) => ({
    get hasPermissions() {
      return self.permissions;
    },
    userHasPermissionTo(permissionId: number) {
      return self.permissions.filter((p: { id: number }) => p.id === permissionId).length > 0;
    },
    userHasOneOfThePermissions(requestedPermissions: number[]) {
      var commonPermissions = self.permissions.filter((p: { id: number }) =>
        requestedPermissions.includes(p.id)
      );
      return commonPermissions.length > 0;
    },
    userHasAllOfThePermissions(requestedPermissions: number[]) {
      return requestedPermissions.every((x) => self.permissions.map((p: any) => p.id).includes(x));
    },
  }));

export type PermissionsService = Instance<typeof PermissionsServiceModel>;
export const permissionsService = PermissionsServiceModel.create(
  {
    cacheKey: "permissions",
  },
  {
    api,
    appSessionStorage,
    organizationSubscriptionService,
  }
);
globalModule.permissionsService = permissionsService;

reaction(
  () => organizationSubscriptionService.data,
  async () => {
    await permissionsService.reloadPermissions();
  }
);
